// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2PUt3","image":"Header_image__tllCZ","name":"Header_name__1vpOz","info":"Header_info__uyeiZ","infoRow":"Header_infoRow__1c3aG"};